<script>
    export let title,
        url,
        type = '',
        openNewTab
</script>

<style type="text/scss">.btn {
  position: relative;
  font-weight: 600;
  display: inline-block;
  font-size: 1rem;
  text-align: center;
  line-height: 1.25;
  text-transform: capitalize;
  border-radius: 0.125rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  background-color: #fff;
  border-color: #4081FF;
  margin-top: 1.5rem;
  margin-right: 0.5rem;
  display: flex;
  align-self: flex-start;
  align-items: center;
  border: 2px solid;
  letter-spacing: 0.08em;
  transition: all 0.3s linear;
  transition-property: background, border-color;
}

.btn svg {
  margin-right: 0.5rem;
  display: inline;
}

.btn svg path {
  fill: currentColor;
}
/*# sourceMappingURL=src/components/Button.svelte.map */</style>

<a target={openNewTab ? '_blank' : ''} class="btn {type}" href={url} download>
    {#if type === 'download'}
        <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M3.98154 5.95352L5.22713 4.97763C5.34714 4.8836 5.5434 4.8836 5.66342 4.97763L7.55067 6.45625V0.440889C7.55067
                0.307989 7.68948 0.199097 7.85929 0.199097H9.62069C9.79032 0.199097 9.92931 0.307846 9.92931
                0.440889V6.45625L11.8166 4.97763C11.9366 4.8836 12.1328 4.8836 12.2529 4.97763L13.4984 5.95352C13.6185 6.04755
                13.6185 6.20131 13.4984 6.29534L8.97391 9.84019C8.90989 9.89035 8.82417 9.91293 8.7399 9.9095C8.65563 9.91293
                8.5699 9.89035 8.50588 9.84019L3.98154 6.29548C3.86152 6.20145 3.86152 6.04755 3.98154 5.95352ZM16.8179
                12.4755V6.89396C16.8179 6.89396 16.8184 6.81851 16.7342 6.75663C16.6689 6.70862 16.576 6.70862 16.576
                6.70862H14.9365C14.9365 6.70862 14.8671 6.70876 14.7931 6.76106C14.7165 6.81522 14.7165 6.88482 14.7165
                6.88482V11.0427H2.76332V6.89396C2.76332 6.89396 2.76386 6.81851 2.6796 6.75663C2.6143 6.70862 2.52146 6.70862
                2.52146 6.70862H0.882079C0.882079 6.70862 0.812769 6.70876 0.738716 6.76106C0.662109 6.81522 0.662109 6.88482
                0.662109 6.88482V12.4792C0.662109 12.5945 0.782673 12.689 0.929867 12.689H16.5454C16.6951 12.6891 16.8179 12.5929
                16.8179 12.4755Z"
                fill="#FFFFFF" />
        </svg>
    {/if}
    {title}
</a>
